import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  IconComponent,
  IsDefinedPipe,
  ItemComponent,
  ItemDescriptionComponent,
  ItemTitleComponent,
  ItemTrailingComponent,
  ResolvableModal,
  TranslatePipe,
} from '@softline/ui-core';
import { EinheitAuswahlItem } from '../../types/einheit-auswahl-item';

@Component({
  selector: 'soft-select-unit',
  imports: [
    ItemComponent,
    ItemTitleComponent,
    ItemDescriptionComponent,
    ItemTrailingComponent,
    IconComponent,
    TranslatePipe,
    IsDefinedPipe,
  ],
  templateUrl: './select-unit.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectUnitDialog extends ResolvableModal<EinheitAuswahlItem> {
  readonly units = input.required<EinheitAuswahlItem[]>();
}
